import { FinancialSummary } from './financialSummary'
import { SalesChannelsAndSalesPeaks } from './salesChannels&SalesPeaks'
import { DashboardAndModalFilterProvider } from './dashboardAndModalFilterContext'
// import { ModalFilters } from './modalFilters'
import { QuantitativeDetails } from './quantitativeDetails'
import { RankingAndMonthlyBalance } from './rankingAndMonthlyBalance'
import { FaSyncAlt } from 'react-icons/fa'
import { useEffect, useState } from 'react'

import { Container, BusinessGraphicsAndDatas } from './style'

export function Dashboard() {
    const [isLoading, setIsLoading] = useState(false)

    // const [modalFiltersOpen, setModalFiltersOpen] = useState(false)


    useEffect(() =>{
        setInterval(() => {
            setIsLoading(true)
        }, 3600000)
    }, [])

    useEffect(() =>{   
        if(isLoading){
            setTimeout(() =>{
                setIsLoading(false)
            }, 10)
        }
    }, [isLoading])


    return(
        <Container>
            {/* <FaEllipsisV 
                className='moreOptions'
            />  */}

            <FaSyncAlt 
                 className="refresh" 
                 onClick={() => setIsLoading(true)}
            />
            
        
            <div className="fill"></div>


            <DashboardAndModalFilterProvider>
                    
                <BusinessGraphicsAndDatas>
                    {
                        isLoading ?
                        <></>
                        :
                        <>
                            <FinancialSummary />
                            <SalesChannelsAndSalesPeaks />
                            <QuantitativeDetails />
                            <RankingAndMonthlyBalance />
                        </>
                    }
                </BusinessGraphicsAndDatas>


                {/* <ModalFilters 
                    modalFiltersOpen={modalFiltersOpen}
                    setModalFiltersOpen={setModalFiltersOpen}
                /> */}

               
            </DashboardAndModalFilterProvider>

        </Container>
    )
}